import React from 'react';

interface IFocus {
  focus: () => void;
}

const useInitialFocus = <Element extends IFocus>() => {
  const focusRef = React.useRef<Element>(null);

  React.useEffect(() => {
    focusRef.current && focusRef.current.focus();
  }, [focusRef]);

  return focusRef;
};

export default useInitialFocus;
